import React, { useState } from 'react';
import {
  Checkbox,
  Col,
  Row,
  Select,
  TextField,
} from '@folio/stripes-components';
import { Field } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import { OnChange } from 'react-final-form-listeners';
import { FieldArray } from 'react-final-form-arrays';
import LocalizedTextField from '../../../../../shared/LocalizedTextField';
import { required } from '../../../../../utils/utils';
import styles from '../../styles.css';
import HelpeEditForm from '../../../../../shared/HelpeEditForm';
import {
  FieldTypesOptions,
  EntityTypes,
  SchemaTypes,
} from '../../../../../constants';

function FormFields() {
  const [isRepeatable, setIsRepeatable] = useState(false);

  return (
    <div className={styles.form_container}>
      <OnChange name="isRepeatable">
        {(value) => {
          setIsRepeatable(value);
        }}
      </OnChange>
      <Row>
        <Col xs={4}>
          <Field
            id="isRepeatable"
            name="isRepeatable"
            component={Checkbox}
            fullWidth
            label={
              <FormattedMessage
                id="ui-plugin-inventory-templates.defaultFields.editForm.formFields.isRepeatable"
                defaultMessage="Is repeatable"
              />
            }
            type="checkbox"
          />
        </Col>
        <Col xs={4}>
          <Field
            id="isRequired"
            name="isRequired"
            component={Checkbox}
            fullWidth
            label={
              <FormattedMessage
                id="ui-plugin-inventory-templates.defaultFields.editForm.formFields.isRequired"
                defaultMessage="Is required"
              />
            }
            type="checkbox"
          />
        </Col>
        <Col xs={4}>
          <Field
            id="canEdit"
            name="canEdit"
            component={Checkbox}
            fullWidth
            label={
              <FormattedMessage
                id="ui-plugin-inventory-templates.defaultFields.editForm.formFields.canEdit"
                defaultMessage="Can edit"
              />
            }
            type="checkbox"
          />
        </Col>
      </Row>
      <hr />
      <pr />
      <Row className={styles.row_container}>
        <Col xs={6}>
          <Row>
            <Col xs={12}>
              <FieldArray
                name="label"
                component={LocalizedTextField}
                fieldComponent={TextField}
                fieldLabel={
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.defaultFields.editForm.formFields.label"
                    defaultMessage="Label"
                  />
                }
              />
            </Col>
            {isRepeatable && (
              <Col xs={12}>
                <FieldArray
                  name="singularLabel"
                  component={LocalizedTextField}
                  fieldComponent={TextField}
                  fieldLabel={
                    <FormattedMessage
                      id="ui-plugin-inventory-templates.defaultFields.editForm.formFields.singularLabel"
                      defaultMessage="Singular Label"
                    />
                  }
                />
              </Col>
            )}
            <Col xs={12}>
              <Field
                component={TextField}
                fullWidth
                name="name"
                label={
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.defaultFields.editForm.formFields.fieldName"
                    defaultMessage="Field name"
                  />
                }
                required
                validate={required}
                type="text"
                disabled
              />
            </Col>
            <Col xs={12}>
              <Field
                component={Select}
                fullWidth
                name="type"
                label={
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.defaultFields.editForm.formFields.fieldType"
                    defaultMessage="Field type"
                  />
                }
                dataOptions={FieldTypesOptions}
                required
                validate={required}
                type="text"
                disabled
              />
            </Col>
            <Col xs={12}>
              <Field
                component={Select}
                fullWidth
                name="schema"
                label={
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.defaultFields.editForm.formFields.schema"
                    defaultMessage="Schema type"
                  />
                }
                dataOptions={SchemaTypes}
                required
                validate={required}
                type="text"
                disabled
              />
            </Col>
            <Col xs={12}>
              <Field
                component={Select}
                fullWidth
                name="entityType"
                label={
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.defaultFields.editForm.formFields.entityType"
                    defaultMessage="Record type"
                  />
                }
                dataOptions={EntityTypes}
                required
                validate={required}
                type="text"
                disabled
              />
            </Col>
          </Row>
        </Col>
        <Col xs={6}>
          <HelpeEditForm />
        </Col>
      </Row>
      <Row>
        <Col xs={4}>
          <Field
            id="lockRepeatableOption"
            name="meta.lockRepeatableOption"
            component={Checkbox}
            fullWidth
            label={
              <FormattedMessage
                id="ui-plugin-inventory-templates.defaultFields.editForm.formFields.lockRepeatableOption"
                defaultMessage="Lock repeatable option"
              />
            }
            type="checkbox"
          />
        </Col>
        <Col xs={4}>
          <Field
            id="lockRequiredOption"
            name="meta.lockRequiredOption"
            component={Checkbox}
            fullWidth
            label={
              <FormattedMessage
                id="ui-plugin-inventory-templates.defaultFields.editForm.formFields.lockRequiredOption"
                defaultMessage="Lock required option"
              />
            }
            type="checkbox"
          />
        </Col>
        <Col xs={4}>
          <Field
            id="lockCanEditOption"
            name="meta.lockCanEditOption"
            component={Checkbox}
            fullWidth
            label={
              <FormattedMessage
                id="ui-plugin-inventory-templates.defaultFields.editForm.formFields.lockCanEditOption"
                defaultMessage="Lock can edit option"
              />
            }
            type="checkbox"
          />
        </Col>
      </Row>
    </div>
  );
}

export default FormFields;
